import { render, staticRenderFns } from "./OrdersPrints.vue?vue&type=template&id=1a53342c&"
import script from "./OrdersPrints.vue?vue&type=script&lang=js&"
export * from "./OrdersPrints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports